import HomePage from "./Homepage";


function App() {
  return (
    <div className="App">
       
          <HomePage/>
      
  
    </div>
  );
}

export default App;
